import React, { ReactElement, ReactNode } from "react";
import MuiLoadingButton from "@mui/lab/LoadingButton";

interface LoadingButtonProps {
    children: ReactNode;
    loading?: boolean;
    color?: "primary" | "secondary";
    onClick?: () => void;
    disabled?: boolean;
}
const LoadingButton = ({ children, loading, onClick, color = "primary", disabled }: LoadingButtonProps): ReactElement => {
    return (
        <MuiLoadingButton variant="contained" color={color} type="submit" loading={loading} onClick={onClick} disabled={disabled}>
            <span>{children}</span>
        </MuiLoadingButton>
    );
};
export default LoadingButton;
